import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText, CircularProgress } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';

export default function GroupsList({ groups, loadingGroups, onSelectGroup, activeChatId = null }) {
  if (loadingGroups) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }
  if (!groups || groups.length === 0) return null;

  return (
    <Box sx={{ flexShrink: 0, maxHeight: '35%', overflow: 'auto' }}>
      <Typography
        variant="caption"
        sx={{
          px: 2,
          py: 0.5,
          display: 'block',
          color: 'text.secondary',
          textTransform: 'uppercase',
          fontWeight: 600,
          fontSize: 11
        }}
      >
        Grupos
      </Typography>
      <List disablePadding>
        {groups.map((g) => (
          <ListItemButton
            key={g.id}
            selected={activeChatId === g.id}
            onClick={() => onSelectGroup(g)}
            sx={{
              mx: 1,
              borderRadius: 1,
              '&:hover': { bgcolor: 'action.hover' },
              '&.Mui-selected': { bgcolor: 'action.selected' },
              '&.Mui-selected:hover': { bgcolor: 'action.selected' }
            }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>
              <GroupIcon sx={{ color: 'primary.main', fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary={g.name || 'Grupo'}
              primaryTypographyProps={{ fontSize: 13, color: 'text.primary' }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
